import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { reduxForm } from 'redux-form';

const ModalForm = (props) => {
  const { isOpen, title, formBuilder, close } = props;

  return (
    <Modal isOpen={isOpen} className="modal-form">
      <ModalHeader toggle={close} className="header">
        {title && <span className="title">{title}</span>}
      </ModalHeader>
      <ModalBody>{formBuilder}</ModalBody>
    </Modal>
  );
};

ModalForm.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  formBuilder: PropTypes.shape(PropTypes.shape).isRequired,
  close: PropTypes.func,
};

ModalForm.defaultProps = {
  title: null,
  close: null,
};

export default reduxForm({
  form: 'ModalForm',
})(withTranslation('common')(ModalForm));
